export default __webpack_public_path__ + "static/media/wordpairs_locked.9e167c71.svg";